import React, { useEffect } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { getters, actions } from "../model";
import { withRouter } from "react-router";
import {
  getLogoImageUrl,
  getLogoImageAltText,
  getBackgroundImageUrl,
  getPortalNameColor,
  getPortalNameFont,
  getPortalNameSize,
  getCssCode,
  getBackgroundImageAltText,
  getBackgroundColor,
  getSelectedCategory,
  getPageTitle,
  getEnableBackgroundFullWidth
} from "../selectors";
import { Style } from "react-style-tag";
import WrapperPage from "Portal/NewPortal/PortalHome/Components/WrapperPage";
import { SECTIONS_IDS } from "../constants";
import { Helmet } from "react-helmet";

import HomeSection from "Portal/NewPortal/Sections/Home";

import SessionsSection from "Portal/NewPortal/Sections/Sessions/View";
import ProfileSection from "Portal/NewPortal/Sections/Profile/View";
import CalendarSection from "Portal/NewPortal/Sections/Calendar/View";
import WikiPageViewer from "Portal/NewPortal/Sections/Resources/View";
import DebugBar from "./DebugBar";
import { getPortalUser } from "redux/modules/portal/user/actions";

const decorate = R.compose(
  connect(
    (state, props) => ({
      loading: getters.loading(state),
      title: getters.title(state),
      description: getters.description(state),
      logoImageUrl: getLogoImageUrl(state),
      logoImageAltText: getLogoImageAltText(state),
      backgroundColor: getBackgroundColor(state),
      backgroundImageUrl: getBackgroundImageUrl(state),
      backgroundImageAltText: getBackgroundImageAltText(state),
      portalNameColor: getPortalNameColor(state),
      portalNameFont: getPortalNameFont(state),
      portalNameSize: getPortalNameSize(state),
      cssCode: getCssCode(state),
      showTasks: getters.show_tasks(state),
      percent_complete: getters.percent_complete(state),
      selectedCategory: getSelectedCategory(state, props),
      pageTitle: getPageTitle(state, props),
      enableBackgroundFullWidth: getEnableBackgroundFullWidth(state)
    }),
    {
      init: actions.init,
      getPortalUser
    }
  ),
  withRouter
);

const Layout = ({
  init,
  // scope,
  title,
  description,
  logoImageUrl,
  logoImageAltText,
  backgroundColor,
  backgroundImageUrl,
  backgroundImageAltText,
  // showTasks,
  // location,
  portalNameColor,
  portalNameFont,
  portalNameSize,
  cssCode,
  selectedCategory,
  loading = true,
  location,
  pageTitle,
  getPortalUser,
  enableBackgroundFullWidth
}) => {
  useEffect(() => {
    init({ selectedCategory, getPortalUser });
  }, []);

  if (loading) {
    return null;
  }

  const ActualView = R.propOr(
    null,
    selectedCategory
  )({
    [SECTIONS_IDS.HOME]: HomeSection,
    [SECTIONS_IDS.SESSIONS]: SessionsSection,
    [SECTIONS_IDS.PROFILE]: ProfileSection,
    // [SECTIONS_IDS.HISTORY]: "history",
    [SECTIONS_IDS.TASKS]: "tasks",
    // [SECTIONS_IDS.FILES]: "files",
    [SECTIONS_IDS.RESOURCES]: WikiPageViewer,
    [SECTIONS_IDS.CALENDAR]: CalendarSection
    // [SECTIONS_IDS.MESSAGES]: "messages"
  });

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{pageTitle}</title>
      </Helmet>
      {cssCode ? <Style>{cssCode}</Style> : null}
      <WrapperPage
        instanceId="home"
        title={title}
        description={description}
        logoImageUrl={logoImageUrl}
        logoImageAltText={logoImageAltText}
        backgroundColor={backgroundColor}
        backgroundImageUrl={backgroundImageUrl}
        backgroundImageAltText={backgroundImageAltText}
        titleStyle={{
          fontFamily: portalNameFont,
          fontSize: portalNameSize,
          color: portalNameColor
        }}
        selectedCategory={selectedCategory}
        enableBackgroundFullWidth={enableBackgroundFullWidth}
      >
        {location.query && location.query.debug ? <DebugBar /> : null}
        {ActualView ? <ActualView /> : null}
      </WrapperPage>
    </>
  );
};

export default decorate(Layout);
